import format from "date-fns/format";
import parse from "date-fns/parse";
import startOfWeek from "date-fns/startOfWeek";
import getDay from "date-fns/getDay";
import { dateFnsLocalizer } from "react-big-calendar";
import moment from "moment";
import enUs from "date-fns/locale/en-US";

const date = new Date();

export const defaultStartDateTime = moment({
  year: date.getFullYear(),
  month: date.getMonth(),
  date: date.getDate(),
})
  .startOf("week")
  .toDate();
export const defaultEndDateTime = moment({
  year: date.getFullYear(),
  month: date.getMonth(),
  date: date.getDate(),
})
  .endOf("week")
  .toDate();

const locales = {
  "en-US": enUs,
};

export const localizer = dateFnsLocalizer({
  format,
  parse,
  startOfWeek,
  getDay,
  locales,
});

export const Roles = {
  PRACTITIONER: "Practitioner",
  ADMINISTRATOR: "Administrator",
};

export const getDefaultStartDateTime = (_date: Date) => {
  const dateValue = _date || new Date();
  return moment({
    year: dateValue.getFullYear(),
    month: dateValue.getMonth(),
    date: dateValue.getDate(),
  })
    .startOf("week")
    .toDate();
};

export const getDefaultEndDateTime = (_date: Date) => {
  const dateValue = _date || new Date();
  return moment({
    year: dateValue.getFullYear(),
    month: dateValue.getMonth(),
    date: dateValue.getDate(),
  })
    .endOf("week")
    .toDate();
};

/**
 * Gets the appropriate date to use from a calendar range.
 * For month view, finds the first day of the actual month being displayed,
 * as rng[0] might be from the previous month if the month starts mid-week.
 * @param rng - Array of dates representing the visible range
 * @param view - The current calendar view ("month", "week", "day", "agenda")
 * @returns The date to use for the calendar date state
 */
export const getDateFromRange = (rng: Date[], view: string): Date => {
  // default to today if no range is provided or if the range is only one day
  if (!Array.isArray(rng) || !rng[0]) {
    return new Date();
  }

  // For month view, find the first day of the actual month being displayed
  if (view === "month" && rng.length > 0) {
    const midIndex = Math.floor(rng.length / 2);
    const midDate = rng[midIndex];
    const targetMonth = midDate.getMonth();
    const targetYear = midDate.getFullYear();

    // Find the first date in the range that matches the target month/year
    const firstDayOfMonth = rng.find(
      (day) =>
        day.getMonth() === targetMonth && day.getFullYear() === targetYear,
    );

    if (firstDayOfMonth) {
      return firstDayOfMonth;
    }

    // Fallback: use the first day of the target month
    return moment({
      year: targetYear,
      month: targetMonth,
      date: 1,
    }).toDate();
  }

  // for day view, use today if the range is only one day
  if (view === "day" && rng.length === 1) {
    return new Date();
  }

  // For other views, use the first date in the range
  return rng[0];
};
